export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";